import { render, staticRenderFns } from "./DrawerTasksTab.vue?vue&type=template&id=5996561e&scoped=true"
import script from "./DrawerTasksTab.vue?vue&type=script&lang=js"
export * from "./DrawerTasksTab.vue?vue&type=script&lang=js"
import style0 from "./DrawerTasksTab.vue?vue&type=style&index=0&id=5996561e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5996561e",
  null
  
)

export default component.exports